<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(importarXml)">
      <b-card class="m-3">
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">Importar convênios / outros instrumentos congêneres</span>
            <btn-voltar />
            <b-button class="float-right m-1" size="sm" type="submit">
              <font-awesome-icon icon="file-upload" />
              Enviar
            </b-button>
          </h6>
        </template>

        <b-row>
          <b-col>
            <div id="fileInputWrapper" class="d-flex align-items-center">
              <validation-provider rules="required" v-slot="validationContext" name="arquivo">
                <b-form-group class="mb-5" id="arquivo-input-group" label="Arquivo (.zip)*" label-for="input-arquivo"
                  label-cols="auto" content-cols="12">
                  <b-form-file v-model="arquivo" :state="getValidationState(validationContext)"
                    placeholder="Escolha um arquivo..." drop-placeholder="Solte o arquivo aqui..."
                    browse-text="Escolher" accept=".zip" @change="temConveniosNaoImportados = false; temConveniosImportados = false; errosValidacao = []"></b-form-file>
                  <b-form-invalid-feedback id="input-arquivo-live-feedback">{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>
          </b-col>
        </b-row>
        <btn-download class="ml-3" v-if="errosValidacao.erros?.length > 0"
                :fazerDownload="baixarRelatorioDeInconsistencias" :texto="'Relatório de inconsistências'" />
        <div v-if="temConveniosImportados" class="conveniosImportadosWrapper">
          <div v-if="itemsImportados.length > 0">
            <span class="mt-3"><b>Instrumentos Importados</b></span>
            <b-table class="tableConveniosImportados mt-3" :fields="fields" hover no-border-collapse :items="itemsImportados" small>
            </b-table>
            <table-pagination :total-rows="itemsImportados.length" :per-page="perPage" @pageChange="pageChange">
            </table-pagination>
          </div>
        </div>
        <br/>
        <div v-if="temConveniosNaoImportados" class="conveniosNaoImportadosWrapper">
          <div v-if="itemsNaoImportados.length > 0">
            <div class="d-flex justify-content-center">
              <span class="mt-3"><b>Instrumentos não Importados</b></span>
            </div>
            
            <b-table class="tableConveniosNaoImportados mt-3" :fields="fields" hover no-border-collapse :items="itemsNaoImportados" small>
            </b-table>
            <table-pagination :total-rows="itemsNaoImportados.length" :per-page="perPage" @pageChange="pageChange">
            </table-pagination>
          </div>
        </div>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import conveniosService from '@/services/licitacoes/conveniosService';
import TablePagination from '@/components/atos-pessoal/TablePagination.vue';
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from '@/components/shared/btn-download.vue'
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';

const CompProps = Vue.extend({
  name: "ImportarXmlConvenio",
  components: {
    ValidationProvider,
    ValidationObserver,
    TablePagination,
    BtnVoltar,
    BtnDownload
  }
})

@Component
export default class ImportarXmlConvenio extends mixins(UtilsTS, CompProps) {
  arquivo: any = null
  temConveniosImportados = false
  temConveniosNaoImportados = false
  errosValidacao: any[] = []
  perPage = 10
  currentPage = 1
  itemsNaoImportados: any[] = []
  itemsImportados: any[] = []
  fields = [
    {
      key: "nrAnoConvenio",
      label: "Nº/Ano Instrumento",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "tipo",
      label: "Tipo",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "objeto",
      label: "Objeto",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "valor",
      label: "Valor",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "dtInicioVigencia",
      label: "Início Vigência",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "dtFimVigencia",
      label: "Fim Vigência",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "dtCelebracao",
      label: "Data de Celebração",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
  ]

  voltar() {
    this.$router.go(-1);
  }

  async importarXml() {
    this.itemsImportados = [];
    this.itemsNaoImportados = [];
    this.temConveniosImportados = false;
    this.temConveniosNaoImportados = false;
    const response = await conveniosService.importarXml(this.arquivo);
    if (response && response.status == 200) {
      this.itemsImportados = response.data.conveniosImportados;
      this.temConveniosImportados = true;
      this.$toast.success('Arquivo importado com sucesso');
    }
    else {
      if (response && response.data.conveniosNaoImportados) 
        this.itemsNaoImportados = response.data.conveniosNaoImportados;
      if (response && response.data.conveniosImportados) 
        this.itemsImportados = response.data.conveniosImportados;
      
      if(this.itemsNaoImportados.length > 0) {
        this.temConveniosNaoImportados = true;
      }
      if(this.itemsImportados.length > 0) {
        this.temConveniosImportados = true;
      }
      if (response) this.errosValidacao = response.data;
      this.$toast.error('Erro ao processar o arquivo enviado');
    }
    //this.$refs.observer.reset();
    this.arquivo = null;
  }

  async baixarRelatorioDeInconsistencias() {
    //console.log("errosValidacao", this.errosValidacao)
    const response = await conveniosService.baixarRelatorioDeInconsistencias(this.errosValidacao);
    if (response && response.status == 200)
      this.download("relatorio-de-inconsistencias-convenios.pdf", response.data);
    else {
      this.$toast.error('Erro ao baixar o relatório de inconsistências');
    }
  }

  getValidationState({ dirty, validated, valid = null }) {
    return dirty || validated ? valid : null;
  }

  pageChange(value: number) {
    this.currentPage = value;
  }
};
</script>

<style scoped>
  :deep(table.b-table div) {
    word-break: inherit
  }

  :deep(.tableConveniosNaoImportados tbody) {
    color: rgb(230, 51, 51);
  }

  :deep(.tableConveniosImportados tbody) {
    color: green;
  }
</style>
